import { createAction, props } from '@ngrx/store';
import { QuickLink } from '../../../models/quicklink.model';

export const setQuickLinkData = createAction('[Quick Link] Set Data', props<{ quickLinkData: QuickLink }>());
